import { useMemo } from "react";

import { HUMANIZE_PROVIDER } from "constants/vcs_providers";
import useTypedContext from "hooks/useTypedContext";
import KeyValue from "components/KeyValue";
import ValuesList from "components/ValuesList";
import useTypedFlags from "hooks/useTypedFlags";

import { StackVcsFormFields } from "../types";
import { StackFormContext } from "../context";

type NewStackSummaryVcsProps = {
  data: StackVcsFormFields;
};

const NewStackSummaryVcs = ({ data }: NewStackSummaryVcsProps) => {
  const { internalData } = useTypedContext(StackFormContext);
  const { enableSparseCheckout } = useTypedFlags();

  const additionalProjectGlobsValues = useMemo(
    () => data.additionalProjectGlobs?.map((glob) => glob.value),
    [data.additionalProjectGlobs]
  );

  const gitSparseCheckoutPathsValues = useMemo(
    () => (enableSparseCheckout ? data.gitSparseCheckoutPaths?.map((path) => path.value) : []),
    [data.gitSparseCheckoutPaths, enableSparseCheckout]
  );

  return (
    <>
      <KeyValue name="Provider">{data.provider && HUMANIZE_PROVIDER[data.provider]}</KeyValue>

      {data.vcsIntegrationId && (
        <KeyValue name="Integration">
          {internalData.vcsIntegrationLabel || data.vcsIntegrationId}
        </KeyValue>
      )}

      {data.repository && data.namespace && (
        <KeyValue name="Repository">{`${data.namespace}/${data.repository}`}</KeyValue>
      )}
      <KeyValue name="Branch">{data.branch}</KeyValue>
      {data.repositoryURL && <KeyValue name="Repository URL">{data.repositoryURL}</KeyValue>}
      {data.projectRoot && <KeyValue name="Project root">{data.projectRoot}</KeyValue>}
      <KeyValue name="Additional project globs">
        {additionalProjectGlobsValues?.length && (
          <ValuesList values={additionalProjectGlobsValues} />
        )}
      </KeyValue>
      {enableSparseCheckout && (
        <KeyValue name="Git sparse checkout paths">
          {gitSparseCheckoutPathsValues?.length && (
            <ValuesList values={gitSparseCheckoutPathsValues} />
          )}
        </KeyValue>
      )}
    </>
  );
};

export default NewStackSummaryVcs;
